import type { ExtendedBlock } from 'widget-components/integrations/CustomPage/types'

export const flattenBlocks = (blocks: ExtendedBlock[]): ExtendedBlock[] => blocks.flatMap(child => {
    if ('children' in child) {
        return [child, ...flattenBlocks(child.children as ExtendedBlock[])]
    }
    if (Array.isArray(child)) {
        return [...flattenBlocks(child)]
    }
    return [child]
})